import React, { memo, useMemo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import IntakeSegmentPreview from '../IntakeSegmentPreview';

import {
  groupedPreviewPartLabelStyles,
  groupedPreviewPartStyles,
  groupedPreviewRailStyles,
} from './IntakeGroupedSegmentPreview.styles';
import { IntakeGroupedSegmentPreviewTestIds } from './IntakeGroupedSegmentPreview.testIds';
import { buildPartPreviewSegments } from './IntakeGroupedSegmentPreview.utils';

/**
 * Preview rail for a grouped multi-photo segment: renders one per-page
 * thumbnail (via the existing IntakeSegmentPreview source loader) per part,
 * each labeled with its contributing file name.
 */
const IntakeGroupedSegmentPreview = ({ segment, segmentName = null, onLoadSource }) => {
  const partSegments = useMemo(() => buildPartPreviewSegments(segment), [segment]);

  return (
    <Box sx={groupedPreviewRailStyles}>
      {partSegments.map(partSegment => (
        <Box
          data-testid={IntakeGroupedSegmentPreviewTestIds.getPartId(partSegment.id)}
          key={partSegment.id}
          sx={groupedPreviewPartStyles}
        >
          <IntakeSegmentPreview
            segment={partSegment}
            segmentName={segmentName}
            onLoadSource={onLoadSource}
          />
          <Typography color="text.secondary" sx={groupedPreviewPartLabelStyles} variant="regular12">
            {partSegment.sourceFileName}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

IntakeGroupedSegmentPreview.propTypes = {
  segment: PropTypes.shape({
    id: PropTypes.string.isRequired,
    jobId: PropTypes.string,
    parts: PropTypes.arrayOf(
      PropTypes.shape({
        sourceIndex: PropTypes.number,
        pageIndex: PropTypes.number,
        sourceFileName: PropTypes.string,
      }),
    ),
  }).isRequired,
  onLoadSource: PropTypes.func.isRequired,
  segmentName: PropTypes.string,
};

export default memo(IntakeGroupedSegmentPreview);
